import {isChildOfElementById} from "../../../domain/common";

window.addEventListener('DOMContentLoaded', (event) => {
        const elOnClickOpen = document.querySelectorAll("[open-on-click]");
        document.onclick = function(e: { target: any; }){
            elOnClickOpen.forEach(function(el:any) {
                let targetId = el.getAttribute("open-on-click");
                let outsideClick = el.getAttribute("close-on-outside-click");
                //console.log('outsideClick: ',outsideClick);
                let targetEl: any = document.getElementById(targetId);
                /*
                            console.log('e.target.id',e.target.id);
                            console.log('targetId',targetId);
                            console.log('el',el.id);
                            console.log('-----------------');
                */

                const $btnClose = document.getElementById(`${targetId}-close`);
                if($btnClose)
                    $btnClose.focus();
                /*open onclick*/
                if(e.target.id === el.id || isChildOfElementById(e.target,el.id)){
                    if (targetEl.style.display === 'none') {
                        targetEl.style.display = 'block';
                    } //else {
                        //targetEl.style.display = 'none';
                    //}
                }
                /*outside click*/
                else if(
                    (e.target.id !== outsideClick && !isChildOfElementById(e.target,outsideClick))
                    || e.target.id === `${targetId}-close`
                    || isChildOfElementById(e.target,`${targetId}-close`)
                        )/**/
                {
                    targetEl.style.display = 'none';
                }

            });
        };
});

export {};